import { pipe } from 'fp-ts/lib/function';
import { parse, refine, string, success } from 'io-ts/lib/Decoder';

const reEncodeStringArray = /^\[.*\]$/;
export const EncodedStringArray = pipe(
	string,
	refine((s): s is string => reEncodeStringArray.test(s), 'EncodedStringArray'),
	parse((s) => {
		if (s === '[]') {
			return success([]);
		} else {
			return success(s.slice(1, -1).split(' '));
		}
	})
);
